var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69762 11.3939C8.50094 11.3939 9.15217 10.7427 9.15217 9.93935C9.15217 9.13603 8.50094 8.48481 7.69762 8.48481C6.8943 8.48481 6.24308 9.13603 6.24308 9.93935C6.24308 10.7427 6.8943 11.3939 7.69762 11.3939ZM7.69762 10.4242C7.96539 10.4242 8.18247 10.2071 8.18247 9.93935C8.18247 9.67158 7.96539 9.4545 7.69762 9.4545C7.42985 9.4545 7.21277 9.67158 7.21277 9.93935C7.21277 10.2071 7.42985 10.4242 7.69762 10.4242Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78853 6.54541V5.57572C4.78853 3.96907 6.09097 2.66663 7.69762 2.66663C9.30427 2.66663 10.6067 3.96907 10.6067 5.57572V6.54541C11.41 6.54541 12.0613 7.19664 12.0613 7.99996V11.8787C12.0613 12.6821 11.41 13.3333 10.6067 13.3333H4.78853C3.98521 13.3333 3.33398 12.6821 3.33398 11.8787V7.99996C3.33398 7.19664 3.98521 6.54541 4.78853 6.54541ZM5.75823 5.57572C5.75823 4.50462 6.62652 3.63632 7.69762 3.63632C8.76872 3.63632 9.63701 4.50462 9.63701 5.57572V6.54541H5.75823V5.57572ZM4.78853 7.51511C4.52076 7.51511 4.30368 7.73218 4.30368 7.99996V11.8787C4.30368 12.1465 4.52076 12.3636 4.78853 12.3636H10.6067C10.8745 12.3636 11.0916 12.1465 11.0916 11.8787V7.99996C11.0916 7.73218 10.8745 7.51511 10.6067 7.51511H4.78853Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.8d5d3c901cfeb536acdd598c3d26170a.svg";
export { ForwardRef as ReactComponent };